export default __webpack_public_path__ + "static/dryingTears-b76b02514e02e85cdfb625fc60e2aeb6.svg";